(() => {
  const root = document.querySelector('[data-voika-web-app]');
  if (!root) return;
  const buttons = [...root.querySelectorAll('[data-voika-install]')];
  const dialog = root.querySelector('dialog');
  const standalone = () => window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
  let promptEvent = null;
  const hideInstalled = () => { if (standalone()) root.hidden = true; };
  const instructions = () => {
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const platform = ios ? 'ios' : /Android/.test(navigator.userAgent) ? 'android' : 'desktop';
    root.querySelectorAll('[data-voika-platform]').forEach(element => { element.hidden = element.dataset.voikaPlatform !== platform; });
    if (!dialog.open) dialog.showModal();
  };
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    promptEvent = event;
  });
  window.addEventListener('appinstalled', () => { promptEvent = null; root.hidden = true; });
  buttons.forEach(button => button.addEventListener('click', async () => {
    if (standalone()) { root.hidden = true; return; }
    if (!promptEvent) { instructions(); return; }
    const currentPrompt = promptEvent;
    promptEvent = null;
    buttons.forEach(element => { element.disabled = true; });
    try {
      await currentPrompt.prompt();
      await currentPrompt.userChoice;
    } catch {
      instructions();
    } finally {
      buttons.forEach(element => { element.disabled = false; });
    }
  }));
  hideInstalled();
})();
